import React, { useState, useEffect } from 'react';

// ═══════════════════════════════════════════════════════════════════════════
// STRATAVERA MED SPA BUYER/SELLER INTAKE PAGE - V4
// With GHL field key mapping, new revenue questions (gross revenue, margin, device value)
// ═══════════════════════════════════════════════════════════════════════════

// Embedded logo (base64 WebP)
const STRATAVERA_LOGO = 'data:image/webp;base64,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';

const StrataVeraMedSpaIntake = () => {
  // ─────────────────────────────────────────────────────────────────────────
  // STATE MANAGEMENT
  // ─────────────────────────────────────────────────────────────────────────
 const [pathway, setPathway] = useState(null); // 'seller' | 'buyer' | null
const [currentStep, setCurrentStep] = useState(0);
const [isSubmitting, setIsSubmitting] = useState(false);
const [isComplete, setIsComplete] = useState(false);
const [readinessScore, setReadinessScore] = useState(null);
const [animateIn, setAnimateIn] = useState(false);
const [errors, setErrors] = useState({});
const [touched, setTouched] = useState({});

// Auto-select pathway from URL parameter
useEffect(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const typeParam = urlParams.get('type');
  if (typeParam === 'seller' || typeParam === 'buyer') {
    setPathway(typeParam);
  }
}, []);
  
  // Seller Form Data
  const [sellerData, setSellerData] = useState({
    // Contact Info
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    // Business Snapshot
    businessName: '',
    yearEstablished: '',
    yearAcquired: '',
    location: '',
    yearsAtLocation: '',
    reasonForSale: '',
    employeeCount: '',
    // Financial Complexity
    hasAccountingSoftware: '',
    financialsUpToDate: '',
    taxReturnsAvailable: '',
    // Revenue Model
    revenueStreams: [],
    annualGrossRevenue: '',
    profitMargin: '',
    // Membership Sub-gate
    activeMemberCount: '',
    membershipsAutoRenew: '',
    membershipsSeparatelyTracked: '',
    // Gift Card Sub-gate
    tracksGiftCardBalances: '',
    // Debt Gate
    hasOutstandingDebt: '',
    debtTypes: [],
    knowsDebtBalance: '',
    // Equipment Gate
    hasMedicalDevices: '',
    deviceOwnership: '',
    deviceValueEstimate: '',
    // Staffing Gate
    staffTypes: [],
    // Compliance Gate
    entityStructure: '',
    hasComplianceIssues: '',
    // Lease Gate
    isLeased: '',
    leaseAllowsAssignment: '',
    // Transition
    openToTransitionSupport: '',
    saleTimeline: '',
  });

  // Buyer Form Data
  const [buyerData, setBuyerData] = useState({
    // Contact Info
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    // Buyer Profile
    buyerType: '',
    ownershipStyle: '',
    // Acquisition Strategy
    purchaseType: '',
    acquisitionTimeline: '',
    // Financing Gate
    fundingMethod: '',
    financingStatus: '',
    // Financial Readiness
    readinessDocs: [],
    // Risk Tolerance
    riskComfort: [],
    dealStructure: [],
    // Clinical Readiness
    isLicensed: '',
    clinicalNeeds: [],
    // Post-Close
    postCloseIntentions: [],
  });

  useEffect(() => {
    setAnimateIn(true);
  }, []);

  // ─────────────────────────────────────────────────────────────────────────
  // VALIDATION RULES
  // ─────────────────────────────────────────────────────────────────────────
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const validatePhone = (phone) => {
    const cleaned = phone.replace(/\D/g, '');
    return cleaned.length >= 10;
  };

  const formatPhone = (value) => {
    const cleaned = value.replace(/\D/g, '');
    if (cleaned.length <= 3) return cleaned;
    if (cleaned.length <= 6) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
  };

  // Validation requirements per step
  const sellerValidation = {
    contact: {
      firstName: { required: true, message: 'First name is required' },
      lastName: { required: true, message: 'Last name is required' },
      email: { required: true, validate: validateEmail, message: 'Please enter a valid email address' },
      phone: { required: true, validate: validatePhone, message: 'Please enter a valid phone number' },
    },
    snapshot: {
      businessName: { required: true, message: 'Business name is required' },
    },
    financial: {
      hasAccountingSoftware: { required: true, message: 'Please select an option' },
      financialsUpToDate: { required: true, message: 'Please select an option' },
      taxReturnsAvailable: { required: true, message: 'Please select an option' },
    },
    revenue: {
      revenueStreams: { required: true, minLength: 1, message: 'Please select at least one revenue stream' },
      hasMedicalDevices: { required: true, message: 'Please select an option' },
      hasOutstandingDebt: { required: true, message: 'Please select an option' },
      isLeased: { required: true, message: 'Please select an option' },
    },
    membership: {
      activeMemberCount: { required: true, message: 'Please enter member count' },
      membershipsAutoRenew: { required: true, message: 'Please select an option' },
    },
    giftcard: {
      tracksGiftCardBalances: { required: true, message: 'Please select an option' },
    },
    debt: {
      debtTypes: { required: true, minLength: 1, message: 'Please select at least one debt type' },
      knowsDebtBalance: { required: true, message: 'Please select an option' },
    },
    equipment: {
      deviceOwnership: { required: true, message: 'Please select an option' },
    },
    staffing: {
      staffTypes: { required: true, minLength: 1, message: 'Please select at least one staff type' },
    },
    compliance: {
      entityStructure: { required: true, message: 'Please select an option' },
      hasComplianceIssues: { required: true, message: 'Please select an option' },
    },
    lease: {
      leaseAllowsAssignment: { required: true, message: 'Please select an option' },
    },
    transition: {
      openToTransitionSupport: { required: true, message: 'Please select an option' },
      saleTimeline: { required: true, message: 'Please select an option' },
    },
  };

  const buyerValidation = {
    contact: {
      firstName: { required: true, message: 'First name is required' },
      lastName: { required: true, message: 'Last name is required' },
      email: { required: true, validate: validateEmail, message: 'Please enter a valid email address' },
      phone: { required: true, validate: validatePhone, message: 'Please enter a valid phone number' },
    },
    profile: {
      buyerType: { required: true, message: 'Please select your buyer type' },
      ownershipStyle: { required: true, message: 'Please select your ownership style' },
    },
    strategy: {
      purchaseType: { required: true, message: 'Please select purchase type' },
      acquisitionTimeline: { required: true, message: 'Please select your timeline' },
    },
    financing: {
      fundingMethod: { required: true, message: 'Please select your funding method' },
    },
    financingDetails: {
      financingStatus: { required: true, message: 'Please select your financing status' },
    },
    readiness: {},
    risk: {},
    clinical: {
      isLicensed: { required: true, message: 'Please select an option' },
    },
    postclose: {},
  };

  const validateStep = (stepId, data, validationRules) => {
    const rules = validationRules[stepId] || {};
    const stepErrors = {};
    
    Object.entries(rules).forEach(([field, rule]) => {
      const value = data[field];
      
      if (rule.required) {
        if (Array.isArray(value)) {
          if (value.length < (rule.minLength || 1)) {
            stepErrors[field] = rule.message;
          }
        } else if (!value || value.trim() === '') {
          stepErrors[field] = rule.message;
        }
      }
      
      if (rule.validate && value && !rule.validate(value)) {
        stepErrors[field] = rule.message;
      }
    });
    
    return stepErrors;
  };

  // ─────────────────────────────────────────────────────────────────────────
  // STYLES (StrataVera Brand System)
  // ─────────────────────────────────────────────────────────────────────────
  const colors = {
    ink: '#020308',
    obsidian: '#1b1f23',
    midnight: '#2d3640',
    olive: '#1e3b34',
    porcelain: '#faf6f0',
    stone: '#d2cbc0',
    sage: '#dbe3dc',
    clay: '#e6d9cc',
    taupe: '#aca296',
    steel: '#6f7c89',
    bronze: '#b46a3b',
    copper: '#c89a6c',
    truegold: '#c1a265',
    softgold: '#d2b88f',
    champagne: '#e0c9c0',
    error: '#c44536',
    errorLight: '#fdf2f1',
  };

  const styles = {
    // Page Container
    page: {
      minHeight: '100vh',
      backgroundColor: colors.porcelain,
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    },
    
    // Hero Section
    hero: {
      background: `linear-gradient(135deg, ${colors.ink} 0%, ${colors.obsidian} 50%, ${colors.midnight} 100%)`,
      padding: '60px 24px 80px',
      textAlign: 'center',
      position: 'relative',
      overflow: 'hidden',
    },
    heroOverlay: {
      position: 'absolute',
      inset: 0,
      background: `radial-gradient(ellipse at 30% 20%, rgba(193, 162, 101, 0.08) 0%, transparent 50%),
                   radial-gradient(ellipse at 70% 80%, rgba(180, 106, 59, 0.06) 0%, transparent 50%)`,
      pointerEvents: 'none',
    },
    heroContent: {
      position: 'relative',
      zIndex: 1,
      maxWidth: '800px',
      margin: '0 auto',
    },
    logo: {
      width: '180px',
      height: 'auto',
      marginBottom: '32px',
      opacity: animateIn ? 1 : 0,
      transform: animateIn ? 'translateY(0)' : 'translateY(20px)',
      transition: 'all 0.8s ease 0.1s',
    },
    subhead: {
      fontFamily: "'Inter', sans-serif",
      fontSize: '11px',
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '0.2em',
      color: colors.truegold,
      marginBottom: '16px',
      opacity: animateIn ? 1 : 0,
      transform: animateIn ? 'translateY(0)' : 'translateY(20px)',
      transition: 'all 0.8s ease 0.2s',
    },
    heroTitle: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: 'clamp(32px, 5vw, 52px)',
      fontWeight: 400,
      color: colors.porcelain,
      lineHeight: 1.1,
      margin: '0 0 20px 0',
      opacity: animateIn ? 1 : 0,
      transform: animateIn ? 'translateY(0)' : 'translateY(20px)',
      transition: 'all 0.8s ease 0.4s',
    },
    heroSubtitle: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: '20px',
      fontStyle: 'italic',
      color: colors.copper,
      margin: '0 0 40px 0',
      opacity: animateIn ? 1 : 0,
      transform: animateIn ? 'translateY(0)' : 'translateY(20px)',
      transition: 'all 0.8s ease 0.6s',
    },
    
    // Pathway Selection
    pathwayContainer: {
      display: 'flex',
      gap: '24px',
      justifyContent: 'center',
      flexWrap: 'wrap',
      marginTop: '32px',
      opacity: animateIn ? 1 : 0,
      transform: animateIn ? 'translateY(0)' : 'translateY(20px)',
      transition: 'all 0.8s ease 0.8s',
    },
    pathwayCard: {
      background: 'rgba(255, 255, 255, 0.03)',
      backdropFilter: 'blur(20px)',
      border: `1px solid rgba(193, 162, 101, 0.2)`,
      padding: '32px 40px',
      cursor: 'pointer',
      transition: 'all 0.4s ease',
      minWidth: '260px',
      maxWidth: '320px',
      position: 'relative',
      overflow: 'hidden',
    },
    pathwayCardHover: {
      border: `1px solid ${colors.truegold}`,
      background: 'rgba(255, 255, 255, 0.06)',
      transform: 'translateY(-4px)',
      boxShadow: `0 20px 40px rgba(193, 162, 101, 0.15)`,
    },
    pathwayIcon: {
      fontSize: '32px',
      marginBottom: '16px',
    },
    pathwayTitle: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: '24px',
      color: colors.porcelain,
      marginBottom: '8px',
    },
    pathwayDesc: {
      fontSize: '14px',
      color: colors.taupe,
      lineHeight: 1.5,
    },
    
    // Form Container
    formSection: {
      maxWidth: '720px',
      margin: '0 auto',
      padding: '60px 24px',
    },
    
    // Progress Bar
    progressContainer: {
      marginBottom: '48px',
    },
    progressBar: {
      height: '3px',
      backgroundColor: colors.stone,
      borderRadius: '2px',
      overflow: 'hidden',
    },
    progressFill: {
      height: '100%',
      backgroundColor: colors.bronze,
      transition: 'width 0.5s ease',
    },
    progressText: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '12px',
      fontSize: '12px',
      color: colors.steel,
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
    },
    
    // Step Card
    stepCard: {
      backgroundColor: '#ffffff',
      border: `1px solid ${colors.stone}`,
      padding: '48px',
      marginBottom: '24px',
    },
    stepTitle: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: '28px',
      color: colors.obsidian,
      marginBottom: '8px',
    },
    stepDesc: {
      fontSize: '15px',
      color: colors.steel,
      marginBottom: '32px',
      lineHeight: 1.6,
    },
    
    // Form Elements
    formGroup: {
      marginBottom: '24px',
    },
    label: {
      display: 'block',
      fontSize: '13px',
      fontWeight: 500,
      color: colors.obsidian,
      marginBottom: '8px',
    },
    requiredStar: {
      color: colors.bronze,
      marginLeft: '2px',
    },
    input: {
      width: '100%',
      padding: '14px 16px',
      fontSize: '15px',
      border: `1px solid ${colors.taupe}`,
      backgroundColor: colors.porcelain,
      color: colors.obsidian,
      transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
      outline: 'none',
      borderRadius: 0,
    },
    inputFocus: {
      borderColor: colors.bronze,
      boxShadow: `0 0 0 3px rgba(180, 106, 59, 0.1)`,
    },
    inputError: {
      borderColor: colors.error,
      backgroundColor: colors.errorLight,
    },
    errorMessage: {
      fontSize: '12px',
      color: colors.error,
      marginTop: '6px',
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
    },
    select: {
      width: '100%',
      padding: '14px 16px',
      fontSize: '15px',
      border: `1px solid ${colors.taupe}`,
      backgroundColor: colors.porcelain,
      color: colors.obsidian,
      cursor: 'pointer',
      appearance: 'none',
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236f7c89' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right 16px center',
      borderRadius: 0,
    },
    
    // Checkbox Group
    checkboxGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
    },
    checkboxLabel: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      cursor: 'pointer',
      padding: '12px 16px',
      border: `1px solid ${colors.stone}`,
      backgroundColor: '#fff',
      transition: 'all 0.3s ease',
    },
    checkboxLabelChecked: {
      borderColor: colors.bronze,
      backgroundColor: 'rgba(180, 106, 59, 0.05)',
    },
    checkbox: {
      width: '20px',
      height: '20px',
      accentColor: colors.bronze,
    },
    
    // Radio Group
    radioGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
    },
    radioLabel: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      cursor: 'pointer',
      padding: '16px 20px',
      border: `1px solid ${colors.stone}`,
      backgroundColor: '#fff',
      transition: 'all 0.3s ease',
    },
    radioLabelChecked: {
      borderColor: colors.bronze,
      backgroundColor: 'rgba(180, 106, 59, 0.05)',
    },
    
    // Buttons
    buttonRow: {
      display: 'flex',
      gap: '16px',
      marginTop: '32px',
    },
    buttonPrimary: {
      flex: 1,
      padding: '16px 32px',
      backgroundColor: colors.bronze,
      color: colors.porcelain,
      fontSize: '13px',
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
    },
    buttonPrimaryHover: {
      backgroundColor: colors.copper,
      transform: 'translateY(-2px)',
      boxShadow: `0 8px 24px rgba(180, 106, 59, 0.3)`,
    },
    buttonPrimaryDisabled: {
      backgroundColor: colors.taupe,
      cursor: 'not-allowed',
      transform: 'none',
    },
    buttonSecondary: {
      padding: '16px 32px',
      backgroundColor: 'transparent',
      color: colors.bronze,
      fontSize: '13px',
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      border: `2px solid ${colors.bronze}`,
      cursor: 'pointer',
      transition: 'all 0.3s ease',
    },
    
    // Validation Summary
    validationSummary: {
      backgroundColor: colors.errorLight,
      border: `1px solid ${colors.error}`,
      padding: '16px 20px',
      marginBottom: '24px',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '12px',
    },
    validationIcon: {
      color: colors.error,
      fontSize: '20px',
      lineHeight: 1,
    },
    validationText: {
      fontSize: '14px',
      color: colors.error,
      lineHeight: 1.5,
    },
    
    // Results Section
    resultsContainer: {
      maxWidth: '800px',
      margin: '0 auto',
      padding: '60px 24px',
    },
    scoreCard: {
      background: `linear-gradient(135deg, ${colors.ink} 0%, ${colors.obsidian} 100%)`,
      padding: '48px',
      textAlign: 'center',
      marginBottom: '32px',
      position: 'relative',
      overflow: 'hidden',
    },
    scoreGlow: {
      position: 'absolute',
      top: '-50%',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '300px',
      height: '300px',
      background: `radial-gradient(circle, rgba(193, 162, 101, 0.2) 0%, transparent 70%)`,
      pointerEvents: 'none',
    },
    scoreNumber: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: '96px',
      fontWeight: 400,
      color: colors.truegold,
      lineHeight: 1,
      position: 'relative',
      zIndex: 1,
    },
    scoreLabel: {
      fontSize: '11px',
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '0.2em',
      color: colors.taupe,
      marginTop: '16px',
      position: 'relative',
      zIndex: 1,
    },
    tierBadge: {
      display: 'inline-block',
      padding: '8px 24px',
      marginTop: '24px',
      fontSize: '12px',
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '0.15em',
      position: 'relative',
      zIndex: 1,
    },
    tierGreen: {
      backgroundColor: 'rgba(30, 59, 52, 0.8)',
      color: '#9fd4c4',
      border: '1px solid rgba(159, 212, 196, 0.3)',
    },
    tierYellow: {
      backgroundColor: 'rgba(193, 162, 101, 0.2)',
      color: colors.truegold,
      border: `1px solid rgba(193, 162, 101, 0.4)`,
    },
    tierRed: {
      backgroundColor: 'rgba(180, 106, 59, 0.2)',
      color: colors.copper,
      border: `1px solid rgba(200, 154, 108, 0.4)`,
    },
    
    // Breakdown Card
    breakdownCard: {
      backgroundColor: '#ffffff',
      border: `1px solid ${colors.stone}`,
      padding: '32px',
      marginBottom: '24px',
    },
    breakdownTitle: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: '22px',
      color: colors.obsidian,
      marginBottom: '24px',
    },
    breakdownItem: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '16px 0',
      borderBottom: `1px solid ${colors.stone}`,
    },
    breakdownLabel: {
      fontSize: '14px',
      color: colors.steel,
    },
    breakdownScore: {
      fontSize: '16px',
      fontWeight: 600,
      color: colors.obsidian,
    },
    
    // Next Steps
    nextStepsCard: {
      backgroundColor: colors.sage,
      padding: '32px',
      marginTop: '32px',
    },
    nextStepsTitle: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: '22px',
      color: colors.obsidian,
      marginBottom: '16px',
    },
    nextStepsText: {
      fontSize: '15px',
      color: colors.midnight,
      lineHeight: 1.7,
    },
    
    // Footer
    footer: {
      textAlign: 'center',
      padding: '48px 24px',
      borderTop: `1px solid ${colors.stone}`,
    },
    footerLogo: {
      width: '120px',
      height: 'auto',
      marginBottom: '12px',
      opacity: 0.8,
    },
    footerTagline: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: '14px',
      fontStyle: 'italic',
      color: colors.bronze,
    },
  };

  // ─────────────────────────────────────────────────────────────────────────
  // SELLER STEPS CONFIGURATION
  // ─────────────────────────────────────────────────────────────────────────
  const sellerSteps = [
    { id: 'contact', title: 'Contact Information', required: true },
    { id: 'snapshot', title: 'Business Snapshot', required: true },
    { id: 'financial', title: 'Financial Complexity', required: true },
    { id: 'revenue', title: 'Revenue Model', required: true },
    { id: 'membership', title: 'Membership Details', conditional: () => sellerData.revenueStreams.includes('memberships') },
    { id: 'giftcard', title: 'Gift Card Tracking', conditional: () => sellerData.revenueStreams.includes('giftcards') },
    { id: 'debt', title: 'Debt & Liabilities', conditional: () => sellerData.hasOutstandingDebt === 'yes' || sellerData.hasOutstandingDebt === 'unsure' },
    { id: 'equipment', title: 'Equipment & Devices', conditional: () => sellerData.hasMedicalDevices === 'yes' },
    { id: 'staffing', title: 'Staffing & Providers', required: true },
    { id: 'compliance', title: 'Compliance & Structure', required: true },
    { id: 'lease', title: 'Lease & Location', conditional: () => sellerData.isLeased === 'yes' },
    { id: 'transition', title: 'Transition & Timeline', required: true },
  ];

  const activeSellerSteps = sellerSteps.filter(step => 
    step.required || (step.conditional && step.conditional())
  );

  // ─────────────────────────────────────────────────────────────────────────
  // BUYER STEPS CONFIGURATION
  // ─────────────────────────────────────────────────────────────────────────
  const buyerSteps = [
    { id: 'contact', title: 'Contact Information', required: true },
    { id: 'profile', title: 'Buyer Profile', required: true },
    { id: 'strategy', title: 'Acquisition Strategy', required: true },
    { id: 'financing', title: 'Financing', required: true },
    { id: 'financingDetails', title: 'Financing Status', conditional: () => buyerData.fundingMethod !== 'cash' && buyerData.fundingMethod !== '' },
    { id: 'readiness', title: 'Financial Readiness', required: true },
    { id: 'risk', title: 'Risk Tolerance', required: true },
    { id: 'clinical', title: 'Clinical Readiness', required: true },
    { id: 'postclose', title: 'Post-Close Intentions', required: true },
  ];

  const activeBuyerSteps = buyerSteps.filter(step => 
    step.required || (step.conditional && step.conditional())
  );

  // ─────────────────────────────────────────────────────────────────────────
  // READINESS SCORE CALCULATOR (Seller)
  // ─────────────────────────────────────────────────────────────────────────
  const calculateReadinessScore = () => {
    let score = 0;
    const breakdown = {};

    // 1. Financial Readiness (30 points)
    let financialScore = 0;
    if (sellerData.hasAccountingSoftware === 'yes') financialScore += 8;
    else if (sellerData.hasAccountingSoftware === 'partial') financialScore += 4;
    if (sellerData.financialsUpToDate === 'yes') financialScore += 12;
    else if (sellerData.financialsUpToDate === 'mostly') financialScore += 6;
    if (sellerData.taxReturnsAvailable === 'yes') financialScore += 10;
    else if (sellerData.taxReturnsAvailable === 'partial') financialScore += 5;
    breakdown.financial = { score: financialScore, max: 30 };
    score += financialScore;

    // 2. Revenue Quality (20 points)
    let revenueScore = 0;
    if (sellerData.revenueStreams.length >= 3) revenueScore += 8;
    else if (sellerData.revenueStreams.length >= 1) revenueScore += 4;
    if (sellerData.revenueStreams.includes('memberships') && sellerData.membershipsSeparatelyTracked === 'yes') revenueScore += 6;
    else if (sellerData.revenueStreams.includes('memberships')) revenueScore += 3;
    if (sellerData.revenueStreams.includes('giftcards') && sellerData.tracksGiftCardBalances === 'yes') revenueScore += 6;
    else if (!sellerData.revenueStreams.includes('giftcards')) revenueScore += 4;
    breakdown.revenue = { score: revenueScore, max: 20 };
    score += revenueScore;

    // 3. Debt & Liability Clarity (15 points)
    let debtScore = 0;
    if (sellerData.hasOutstandingDebt === 'no') {
      debtScore = 15;
    } else if (sellerData.hasOutstandingDebt === 'yes') {
      if (sellerData.debtTypes.length > 0) debtScore += 7;
      if (sellerData.knowsDebtBalance === 'yes') debtScore += 8;
    }
    breakdown.debt = { score: debtScore, max: 15 };
    score += debtScore;

    // 4. Operational & Staffing Stability (15 points)
    let staffingScore = 0;
    if (sellerData.staffTypes.length > 0) staffingScore += 7;
    if (sellerData.staffTypes.length >= 3) staffingScore += 4;
    if (sellerData.staffTypes.includes('medical_director')) staffingScore += 4;
    breakdown.staffing = { score: staffingScore, max: 15 };
    score += staffingScore;

    // 5. Compliance & Structure (10 points)
    let complianceScore = 0;
    if (sellerData.entityStructure && sellerData.entityStructure !== 'unsure') complianceScore += 5;
    if (sellerData.hasComplianceIssues === 'no') complianceScore += 5;
    else if (sellerData.hasComplianceIssues === 'yes') complianceScore += 2;
    breakdown.compliance = { score: complianceScore, max: 10 };
    score += complianceScore;

    // 6. Market & Brand (10 points)
    let brandScore = 0;
    if (sellerData.yearsAtLocation && parseInt(sellerData.yearsAtLocation) >= 3) brandScore += 5;
    else if (sellerData.yearsAtLocation && parseInt(sellerData.yearsAtLocation) >= 1) brandScore += 3;
    if (sellerData.isLeased === 'yes' && sellerData.leaseAllowsAssignment === 'yes') brandScore += 5;
    else if (sellerData.isLeased === 'no') brandScore += 4;
    breakdown.brand = { score: brandScore, max: 10 };
    score += brandScore;

    const tier = score >= 80 ? 'market-ready' : score >= 60 ? 'optimizable' : 'not-ready';

    return { total: score, breakdown, tier };
  };

  // ─────────────────────────────────────────────────────────────────────────
  // GHL WEBHOOK INTEGRATION (via Make.com)
  // ─────────────────────────────────────────────────────────────────────────
    const GHL_WEBHOOK_URL = 'https://hook.us2.make.com/x2qgehkttb1ho4yo8rd63soyoptvh1ay';
   const submitToGHL = async (data, type, score = null) => {
    const payload = {
  // Contact fields - GHL expects camelCase
  firstName: data.firstName,
  lastName: data.lastName,
  email: data.email,
  phone: data.phone,
  
  // Tags as comma-separated string
  tags: [
    `medspa_${type}`,
    type === 'seller' && score ? `readiness_${score.tier}` : null,
    type === 'buyer' ? `buyer_type_${data.buyerType}` : null,
    type === 'buyer' && data.fundingMethod ? `funding_${data.fundingMethod}` : null,
  ].filter(Boolean),
  
  // Source tracking
  source: 'medspa_intake_landing_page',
  contact_type: type,
  intake_source: 'medspa_intake_landing_page',
  
  // Custom fields - flatten them (not nested)
  ...( type === 'seller' ? {
    seller_business_name: data.businessName,
    seller_year_established: data.yearEstablished || '',
    seller_year_acquired: data.yearAcquired || '',
    seller_business_location: data.location || '',
    seller_years_at_location: data.yearsAtLocation || '',
    seller_reason_for_sale: data.reasonForSale || '',
    employee_count: data.employeeCount || '',
    seller_accounting_software: data.hasAccountingSoftware,
    seller_financials_up_to_date: data.financialsUpToDate,
    seller_tax_returns_current_available: data.taxReturnsAvailable,
    seller_revenue_streams: data.revenueStreams.join(', '),
    seller_annual_gross_revenue: data.annualGrossRevenue || '',
    seller_profit_margin: data.profitMargin || '',
    seller_active_member_count: data.activeMemberCount || '',
    seller_memberships_autorenew: data.membershipsAutoRenew || '',
    seller_tracks_gift_cards: data.tracksGiftCardBalances || '',
    seller_has_outstanding_debt: data.hasOutstandingDebt,
    seller_debt_types: data.debtTypes.join(', ') || '',
    seller_knows_debt_balance: data.knowsDebtBalance || '',
    seller_has_medical_devices: data.hasMedicalDevices,
    seller_device_ownership: data.deviceOwnership || '',
    seller_device_value_estimate: data.deviceValueEstimate || '',
    seller_staff_types: data.staffTypes.join(', '),
    seller_entity_structure: data.entityStructure,
    seller_has_compliance_issues: data.hasComplianceIssues,
    seller_is_leased: data.isLeased,
    seller_lease_allows_assignment: data.leaseAllowsAssignment || '',
    seller_open_to_transition_support: data.openToTransitionSupport,
    seller_sale_timeline: data.saleTimeline,
    seller_readiness_score: score?.total || 0,
    seller_readiness_tier: score?.tier || '',
    seller_financial_score: score?.breakdown?.financial?.score || 0,
    seller_revenue_score: score?.breakdown?.revenue?.score || 0,
    seller_debt_score: score?.breakdown?.debt?.score || 0,
    seller_staffing_score: score?.breakdown?.staffing?.score || 0,
    seller_compliance_score: score?.breakdown?.compliance?.score || 0,
    seller_brand_score: score?.breakdown?.brand?.score || 0,
  } : {
    buyer_type: data.buyerType,
    ownership_style: data.ownershipStyle,
    purchase_type: data.purchaseType,
    acquisition_timeline: data.acquisitionTimeline,
    buyer_funding_method: data.fundingMethod,
    buyer_financing_status: data.financingStatus || '',
    buyer_readiness_docs: data.readinessDocs?.join(', ') || '',
    risk_comfort: data.riskComfort?.join(', ') || '',
    buyer_deal_structure_preferences: data.dealStructure?.join(', ') || '',
    buyer_is_licensed: data.isLicensed,
    buyer_clinical_needs: data.clinicalNeeds?.join(', ') || '',
    buyer_postclose_intentions: data.postCloseIntentions?.join(', ') || '',
  }),
};
    try {
      const response = await fetch(GHL_WEBHOOK_URL, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      
      console.log('GHL Webhook Response:', response.status);
      console.log('Payload sent:', payload);
      return response.ok;
    } catch (error) {
      console.error('GHL Submission Error:', error);
      // Still return true to show results to user even if webhook fails
      return true;
    }
  };

  // ─────────────────────────────────────────────────────────────────────────
  // FORM HANDLERS
  // ─────────────────────────────────────────────────────────────────────────

  const handleCheckboxChange = (field, value, checked, setter, data) => {
    const current = data[field] || [];
    const updated = checked 
      ? [...current, value]
      : current.filter(v => v !== value);
    setter(prev => ({ ...prev, [field]: updated }));
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: null }));
    }
  };

  const handleBlur = (field) => {
    setTouched(prev => ({ ...prev, [field]: true }));
  };

  const handleNext = () => {
    const steps = pathway === 'seller' ? activeSellerSteps : activeBuyerSteps;
    const step = steps[currentStep];
    const data = pathway === 'seller' ? sellerData : buyerData;
    const validation = pathway === 'seller' ? sellerValidation : buyerValidation;
    
    const stepErrors = validateStep(step.id, data, validation);
    
    if (Object.keys(stepErrors).length > 0) {
      setErrors(stepErrors);
      // Mark all fields in this step as touched
      Object.keys(stepErrors).forEach(field => {
        setTouched(prev => ({ ...prev, [field]: true }));
      });
      return;
    }
    
    setErrors({});
    if (currentStep < steps.length - 1) {
      setCurrentStep(prev => prev + 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleBack = () => {
    setErrors({});
    if (currentStep > 0) {
      setCurrentStep(prev => prev - 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleSubmit = async () => {
    const steps = pathway === 'seller' ? activeSellerSteps : activeBuyerSteps;
    const step = steps[currentStep];
    const data = pathway === 'seller' ? sellerData : buyerData;
    const validation = pathway === 'seller' ? sellerValidation : buyerValidation;
    
    const stepErrors = validateStep(step.id, data, validation);
    
    if (Object.keys(stepErrors).length > 0) {
      setErrors(stepErrors);
      return;
    }
    
    setIsSubmitting(true);
    
    let score = null;
    if (pathway === 'seller') {
      score = calculateReadinessScore();
      setReadinessScore(score);
    }

    console.log('PATHWAY VALUE:', pathway);  // ← ADD THIS LINE
    
    await submitToGHL(data, pathway, score);
    
    setIsSubmitting(false);
    setIsComplete(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // ─────────────────────────────────────────────────────────────────────────
  // RENDER HELPERS
  // ─────────────────────────────────────────────────────────────────────────
  const [focusedField, setFocusedField] = useState(null);
  const [hoveredButton, setHoveredButton] = useState(null);
  const [hoveredPathway, setHoveredPathway] = useState(null);

  const renderInput = (field, label, placeholder, data, setter, type = 'text', required = false) => {
    const hasError = touched[field] && errors[field];
    const isPhone = type === 'tel';
    
    return (
      <div style={styles.formGroup}>
        <label style={styles.label}>
          {label}
          {required && <span style={styles.requiredStar}>*</span>}
        </label>
        <input
          type={type}
          value={data[field] || ''}
          onChange={(e) => {
            const value = isPhone ? formatPhone(e.target.value) : e.target.value;
            setter(prev => ({ ...prev, [field]: value }));
            if (errors[field]) setErrors(prev => ({ ...prev, [field]: null }));
          }}
          onBlur={() => handleBlur(field)}
          placeholder={placeholder}
          style={{
            ...styles.input,
            ...(focusedField === field ? styles.inputFocus : {}),
            ...(hasError ? styles.inputError : {}),
          }}
          onFocus={() => setFocusedField(field)}
        />
        {hasError && (
          <div style={styles.errorMessage}>
            <span>⚠</span> {errors[field]}
          </div>
        )}
      </div>
    );
  };

  const renderSelect = (field, label, options, data, setter, required = false) => {
    const hasError = touched[field] && errors[field];
    
    return (
      <div style={styles.formGroup}>
        <label style={styles.label}>
          {label}
          {required && <span style={styles.requiredStar}>*</span>}
        </label>
        <select
          value={data[field] || ''}
          onChange={(e) => {
            setter(prev => ({ ...prev, [field]: e.target.value }));
            if (errors[field]) setErrors(prev => ({ ...prev, [field]: null }));
          }}
          onBlur={() => handleBlur(field)}
          style={{
            ...styles.select,
            ...(hasError ? styles.inputError : {}),
          }}
        >
          <option value="">Select an option</option>
          {options.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
        {hasError && (
          <div style={styles.errorMessage}>
            <span>⚠</span> {errors[field]}
          </div>
        )}
      </div>
    );
  };

  const renderRadioGroup = (field, label, options, data, setter, required = false) => {
    const hasError = errors[field];
    
    return (
      <div style={styles.formGroup}>
        <label style={styles.label}>
          {label}
          {required && <span style={styles.requiredStar}>*</span>}
        </label>
        <div style={styles.radioGroup}>
          {options.map(opt => (
            <label
              key={opt.value}
              style={{
                ...styles.radioLabel,
                ...(data[field] === opt.value ? styles.radioLabelChecked : {}),
              }}
            >
              <input
                type="radio"
                name={field}
                value={opt.value}
                checked={data[field] === opt.value}
                onChange={(e) => {
                  setter(prev => ({ ...prev, [field]: e.target.value }));
                  if (errors[field]) setErrors(prev => ({ ...prev, [field]: null }));
                }}
                style={{ accentColor: colors.bronze }}
              />
              <span>{opt.label}</span>
            </label>
          ))}
        </div>
        {hasError && (
          <div style={styles.errorMessage}>
            <span>⚠</span> {errors[field]}
          </div>
        )}
      </div>
    );
  };

  const renderCheckboxGroup = (field, label, options, data, setter, required = false) => {
    const hasError = errors[field];
    
    return (
      <div style={styles.formGroup}>
        <label style={styles.label}>
          {label}
          {required && <span style={styles.requiredStar}>*</span>}
        </label>
        <div style={styles.checkboxGroup}>
          {options.map(opt => (
            <label
              key={opt.value}
              style={{
                ...styles.checkboxLabel,
                ...(data[field]?.includes(opt.value) ? styles.checkboxLabelChecked : {}),
              }}
            >
              <input
                type="checkbox"
                checked={data[field]?.includes(opt.value) || false}
                onChange={(e) => handleCheckboxChange(field, opt.value, e.target.checked, setter, data)}
                style={styles.checkbox}
              />
              <span>{opt.label}</span>
            </label>
          ))}
        </div>
        {hasError && (
          <div style={styles.errorMessage}>
            <span>⚠</span> {errors[field]}
          </div>
        )}
      </div>
    );
  };

  // ─────────────────────────────────────────────────────────────────────────
  // SELLER STEP CONTENT
  // ─────────────────────────────────────────────────────────────────────────
  const renderSellerStep = () => {
    const step = activeSellerSteps[currentStep];
    if (!step) return null;

    switch (step.id) {
      case 'contact':
        return (
          <div style={styles.stepCard}>
            <h2 style={styles.stepTitle}>Let's Start With You</h2>
            <p style={styles.stepDesc}>
              Your information stays confidential. We'll use it to personalize your experience and reach out with insights.
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
              {renderInput('firstName', 'First Name', 'Jane', sellerData, setSellerData, 'text', true)}
              {renderInput('lastName', 'Last Name', 'Smith', sellerData, setSellerData, 'text', true)}
            </div>
            {renderInput('email', 'Email', 'jane@example.com', sellerData, setSellerData, 'email', true)}
            {renderInput('phone', 'Phone', '(555) 123-4567', sellerData, setSellerData, 'tel', true)}
          </div>
        );
      
      case 'snapshot':
        return (
          <div style={styles.stepCard}>
            <h2 style={styles.stepTitle}>Business Snapshot</h2>
            <p style={styles.stepDesc}>
              Help us understand the fundamentals of your business. This shapes everything that follows.
            </p>
            {renderInput('businessName', 'Business Name', 'Glow Med Spa', sellerData, setSellerData, 'text', true)}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
              {renderInput('yearEstablished', 'Year Established', '2018', sellerData, setSellerData)}
              {renderInput('yearAcquired', 'Year You Acquired (if applicable)', '2020', sellerData, setSellerData)}
            </div>
            {renderInput('location', 'Business Location (City, State)', 'Austin, TX', sellerData, setSellerData, 'text', false)}
            {renderInput('yearsAtLocation', 'Years at Current Location', '4', sellerData, setSellerData)}
            {renderSelect('employeeCount', 'Number of Employees & Contractors', [
              { value: '1-3', label: '1-3' },
              { value: '4-7', label: '4-7' },
              { value: '8-15', label: '8-15' },
              { value: '16+', label: '16+' },
            ], sellerData, setSellerData, false)}
            {renderSelect('reasonForSale', 'Primary Reason for Selling', [
              { value: 'retirement', label: 'Retirement' },
              { value: 'new_venture', label: 'Pursuing New Venture' },
              { value: 'burnout', label: 'Burnout / Lifestyle Change' },
              { value: 'relocation', label: 'Relocation' },
              { value: 'health', label: 'Health Reasons' },
              { value: 'partnership', label: 'Partnership Dissolution' },
              { value: 'other', label: 'Other' },
            ], sellerData, setSellerData)}
          </div>
        );

      case 'financial':
        return (
          <div style={styles.stepCard}>
            <h2 style={styles.stepTitle}>Financial Complexity</h2>
            <p style={styles.stepDesc}>
              Understanding where your finances stand helps us determine readiness and identify any cleanup needed.
            </p>
            {renderRadioGroup('hasAccountingSoftware', 'Do you track your finances using accounting software?', [
              { value: 'yes', label: 'Yes (QuickBooks, Xero, Zoho, or similar)' },
              { value: 'partial', label: 'Partially — some things are tracked' },
              { value: 'no', label: 'No formal system' },
            ], sellerData, setSellerData, true)}
            {renderRadioGroup('financialsUpToDate', 'Are your financials up to date through the most recent month?', [
              { value: 'yes', label: 'Yes, fully current' },
              { value: 'mostly', label: 'Mostly — within 2-3 months' },
              { value: 'no', label: 'No — significantly behind' },
            ], sellerData, setSellerData, true)}
            {renderRadioGroup('taxReturnsAvailable', 'Do you have business tax returns filed for the last 3 years?', [
              { value: 'yes', label: 'Yes, all 3 years' },
              { value: 'partial', label: 'Partially — some years missing' },
              { value: 'no', label: 'No' },
            ], sellerData, setSellerData, true)}
          </div>
        );

      case 'revenue':
        return (
          <div style={styles.stepCard}>
            <h2 style={styles.stepTitle}>Revenue Model</h2>
            <p style={styles.stepDesc}>
              Which revenue streams does your business currently offer? Select all that apply.
            </p>
            {renderCheckboxGroup('revenueStreams', 'Revenue Streams', [
              { value: 'injectables', label: 'Injectables (Botox, fillers, neurotoxins)' },
              { value: 'laser', label: 'Laser / Energy-Based Devices' },
              { value: 'facials', label: 'Facials & Aesthetic Services' },
              { value: 'retail', label: 'Retail Products' },
              { value: 'memberships', label: 'Memberships' },
              { value: 'giftcards', label: 'Gift Cards / Prepaid Packages' },
            ], sellerData, setSellerData, true)}
            {renderSelect('annualGrossRevenue', 'Approximate Annual Gross Revenue', [
              { value: 'under_300k', label: 'Under $300,000' },
              { value: '300k_600k', label: '$300,000 - $600,000' },
              { value: '600k_900k', label: '$600,000 - $900,000' },
              { value: '900k_1.5m', label: '$900,000 - $1.5 Million' },
              { value: '1.5m_3m', label: '$1.5 Million - $3 Million' },
              { value: '3m_5m', label: '$3 Million - $5 Million' },
              { value: '5m_10m', label: '$5 Million - $10 Million' },
              { value: 'over_10m', label: 'Over $10 Million' },
            ], sellerData, setSellerData)}
            {renderSelect('profitMargin', 'Estimated Profit Margin', [
              { value: 'negative', label: 'Currently operating at a loss' },
              { value: 'under_10', label: 'Under 10%' },
              { value: '10_15', label: '10% - 15%' },
              { value: '15_20', label: '15% - 20%' },
              { value: '20_25', label: '20% - 25%' },
              { value: '25_30', label: '25% - 30%' },
              { value: 'over_30', label: 'Over 30%' },
              { value: 'unsure', label: 'Not sure' },
            ], sellerData, setSellerData)}
            {renderRadioGroup('hasMedicalDevices', 'Does the business use medical or aesthetic devices (lasers, EBDs)?', [
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' },
            ], sellerData, setSellerData, true)}
            {renderRadioGroup('hasOutstandingDebt', 'Does the business currently have any outstanding debt or financing?', [
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' },
              { value: 'unsure', label: 'Not sure' },
            ], sellerData, setSellerData, true)}
            {renderRadioGroup('isLeased', 'Does the business operate from a leased location?', [
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No — we own the property' },
            ], sellerData, setSellerData, true)}
          </div>
        );

      case 'membership':
        return (
          <div style={styles.stepCard}>
            <h2 style={styles.stepTitle}>Membership Details</h2>
            <p style={styles.stepDesc}>
              Since you offer memberships, let's capture a few more details for accurate valuation.
            </p>
            {renderInput('activeMemberCount', 'Approximately how many active members do you have?', '150', sellerData, setSellerData, 'text', true)}
            {renderRadioGroup('membershipsAutoRenew', 'Do memberships auto-renew?', [
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' },
            ], sellerData, setSellerData, true)}
            {renderRadioGroup('membershipsSeparatelyTracked', 'Are membership payments tracked separately in your accounting system?', [
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' },
              { value: 'unsure', label: 'Not sure' },
            ], sellerData, setSellerData)}
          </div>
        );

      case 'giftcard':
        return (
          <div style={styles.stepCard}>
            <h2 style={styles.stepTitle}>Gift Card Tracking</h2>
            <p style={styles.stepDesc}>
              Outstanding gift card balances can impact valuation. Let's understand your tracking.
            </p>
            {renderRadioGroup('tracksGiftCardBalances', 'Do you track outstanding gift card or account credit balances?', [
              { value: 'yes', label: 'Yes — we know our liability' },
              { value: 'no', label: 'No' },
              { value: 'unsure', label: 'Not sure' },
            ], sellerData, setSellerData, true)}
          </div>
        );

      case 'debt':
        return (
          <div style={styles.stepCard}>
            <h2 style={styles.stepTitle}>Debt & Liabilities</h2>
            <p style={styles.stepDesc}>
              Understanding your debt structure is critical for deal structuring. No judgment — just clarity.
            </p>
            {renderCheckboxGroup('debtTypes', 'What types of debt exist? (Select all that apply)', [
              { value: 'equipment', label: 'Equipment Financing' },
              { value: 'term_loan', label: 'Business Term Loans' },
              { value: 'mca', label: 'Merchant Cash Advances / Revenue-Based Loans' },
              { value: 'credit_cards', label: 'Credit Cards' },
              { value: 'personal', label: 'Personal Loans Used for Business' },
            ], sellerData, setSellerData, true)}
            {renderRadioGroup('knowsDebtBalance', 'Are you aware of the approximate total outstanding balance?', [
              { value: 'yes', label: 'Yes — I know the amounts' },
              { value: 'no', label: 'No — would need to gather this' },
            ], sellerData, setSellerData, true)}
          </div>
        );

      case 'equipment':
        return (
          <div style={styles.stepCard}>
            <h2 style={styles.stepTitle}>Equipment & Devices</h2>
            <p style={styles.stepDesc}>
              Medical and aesthetic devices are significant assets. Let's understand your situation.
            </p>
            {renderRadioGroup('deviceOwnership', 'Are your devices:', [
              { value: 'owned', label: 'Owned outright' },
              { value: 'financed', label: 'Financed' },
              { value: 'leased', label: 'Leased' },
              { value: 'combination', label: 'Combination' },
            ], sellerData, setSellerData, true)}
            {renderSelect('deviceValueEstimate', 'Estimated Total Value of Medical Devices', [
              { value: 'under_25k', label: 'Under $25,000' },
              { value: '25k_50k', label: '$25,000 - $50,000' },
              { value: '50k_100k', label: '$50,000 - $100,000' },
              { value: '100k_200k', label: '$100,000 - $200,000' },
              { value: '200k_500k', label: '$200,000 - $500,000' },
              { value: 'over_500k', label: 'Over $500,000' },
              { value: 'unsure', label: 'Not sure' },
            ], sellerData, setSellerData)}
          </div>
        );

      case 'staffing':
        return (
          <div style={styles.stepCard}>
            <h2 style={styles.stepTitle}>Staffing & Providers</h2>
            <p style={styles.stepDesc}>
              Clinical structure affects regulatory compliance and transferability.
            </p>
            {renderCheckboxGroup('staffTypes', 'Who currently works in the business? (Select all that apply)', [
              { value: 'rn', label: 'RN(s)' },
              { value: 'np_pa', label: 'NP(s) / PA(s)' },
              { value: 'medical_director', label: 'Medical Director' },
              { value: 'contractors', label: 'Independent Contractors' },
              { value: 'aestheticians', label: 'Aestheticians' },
              { value: 'admin', label: 'Administrative / Front Desk' },
            ], sellerData, setSellerData, true)}
          </div>
        );

      case 'compliance':
        return (
          <div style={styles.stepCard}>
            <h2 style={styles.stepTitle}>Compliance & Structure</h2>
            <p style={styles.stepDesc}>
              Entity structure and compliance history matter for deal feasibility.
            </p>
            {renderSelect('entityStructure', 'How is the business structured?', [
              { value: 'llc', label: 'LLC' },
              { value: 'scorp', label: 'S-Corp' },
              { value: 'ccorp', label: 'C-Corp' },
              { value: 'pc', label: 'Professional Corporation (PC)' },
              { value: 'pc_mso', label: 'PC + MSO Structure' },
              { value: 'sole_prop', label: 'Sole Proprietorship' },
              { value: 'unsure', label: 'Not sure' },
            ], sellerData, setSellerData, true)}
            {renderRadioGroup('hasComplianceIssues', 'Have you ever been notified of a compliance or licensing issue?', [
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' },
            ], sellerData, setSellerData, true)}
          </div>
        );

      case 'lease':
        return (
          <div style={styles.stepCard}>
            <h2 style={styles.stepTitle}>Lease & Location</h2>
            <p style={styles.stepDesc}>
              Lease assignability can make or break financing. Let's understand your situation.
            </p>
            {renderRadioGroup('leaseAllowsAssignment', 'Do you know if the lease allows assignment or transfer?', [
              { value: 'yes', label: 'Yes — it allows assignment' },
              { value: 'no', label: 'No — it doesn\'t allow assignment' },
              { value: 'unsure', label: 'Not sure' },
            ], sellerData, setSellerData, true)}
          </div>
        );

      case 'transition':
        return (
          <div style={styles.stepCard}>
            <h2 style={styles.stepTitle}>Transition & Timeline</h2>
            <p style={styles.stepDesc}>
              Understanding your goals helps us position the business for the right buyer.
            </p>
            {renderRadioGroup('openToTransitionSupport', 'Are you open to providing transition support post-sale?', [
              { value: 'yes', label: 'Yes — I\'m willing to help' },
              { value: 'no', label: 'No — prefer clean break' },
              { value: 'negotiable', label: 'Negotiable' },
            ], sellerData, setSellerData, true)}
            {renderRadioGroup('saleTimeline', 'Ideal sale timeline:', [
              { value: 'immediate', label: 'Immediate (0-3 months)' },
              { value: 'short', label: 'Short-term (3-6 months)' },
              { value: 'flexible', label: 'Flexible' },
            ], sellerData, setSellerData, true)}
          </div>
        );

      default:
        return null;
    }
  };

  // ─────────────────────────────────────────────────────────────────────────
  // BUYER STEP CONTENT
  // ─────────────────────────────────────────────────────────────────────────
  const renderBuyerStep = () => {
    const step = activeBuyerSteps[currentStep];
    if (!step) return null;

    switch (step.id) {
      case 'contact':
        return (
          <div style={styles.stepCard}>
            <h2 style={styles.stepTitle}>Let's Start With You</h2>
            <p style={styles.stepDesc}>
              Your information stays confidential. We'll use it to match you with the right opportunities.
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
              {renderInput('firstName', 'First Name', 'John', buyerData, setBuyerData, 'text', true)}
              {renderInput('lastName', 'Last Name', 'Doe', buyerData, setBuyerData, 'text', true)}
            </div>
            {renderInput('email', 'Email', 'john@example.com', buyerData, setBuyerData, 'email', true)}
            {renderInput('phone', 'Phone', '(555) 123-4567', buyerData, setBuyerData, 'tel', true)}
          </div>
        );

      case 'profile':
        return (
          <div style={styles.stepCard}>
            <h2 style={styles.stepTitle}>Buyer Profile</h2>
            <p style={styles.stepDesc}>
              Help us understand your background and how you plan to operate.
            </p>
            {renderRadioGroup('buyerType', 'What best describes you?', [
              { value: 'first_time', label: 'First-time med spa buyer' },
              { value: 'existing_owner', label: 'Existing med spa owner' },
              { value: 'healthcare_pro', label: 'Healthcare professional' },
              { value: 'investor', label: 'Investor / Operator' },
            ], buyerData, setBuyerData, true)}
            {renderRadioGroup('ownershipStyle', 'Will you be an owner-operator or absentee owner?', [
              { value: 'operator', label: 'Owner-operator' },
              { value: 'semi_absentee', label: 'Semi-absentee' },
              { value: 'absentee', label: 'Absentee' },
            ], buyerData, setBuyerData, true)}
          </div>
        );

      case 'strategy':
        return (
          <div style={styles.stepCard}>
            <h2 style={styles.stepTitle}>Acquisition Strategy</h2>
            <p style={styles.stepDesc}>
              Understanding your approach helps us match you with the right opportunities.
            </p>
            {renderRadioGroup('purchaseType', 'Are you purchasing:', [
              { value: 'assets', label: 'Assets only' },
              { value: 'equity', label: 'Equity / ownership interest' },
              { value: 'unsure', label: 'Not sure yet' },
            ], buyerData, setBuyerData, true)}
            {renderRadioGroup('acquisitionTimeline', 'Target acquisition timeline:', [
              { value: 'asap', label: 'ASAP' },
              { value: '3-6months', label: '3-6 months' },
              { value: 'flexible', label: 'Flexible' },
            ], buyerData, setBuyerData, true)}
          </div>
        );

      case 'financing':
        return (
          <div style={styles.stepCard}>
            <h2 style={styles.stepTitle}>Financing</h2>
            <p style={styles.stepDesc}>
              This is the most important factor in deal readiness. Let's understand your position.
            </p>
            {renderRadioGroup('fundingMethod', 'How do you plan to fund the purchase?', [
              { value: 'cash', label: 'Cash' },
              { value: 'sba', label: 'SBA Loan' },
              { value: 'conventional', label: 'Conventional Bank Loan' },
              { value: 'private', label: 'Private Financing' },
              { value: 'combination', label: 'Combination' },
            ], buyerData, setBuyerData, true)}
          </div>
        );

      case 'financingDetails':
        return (
          <div style={styles.stepCard}>
            <h2 style={styles.stepTitle}>Financing Status</h2>
            <p style={styles.stepDesc}>
              Where are you in the financing process?
            </p>
            {renderRadioGroup('financingStatus', 'Have you:', [
              { value: 'prequalified', label: 'Pre-qualified' },
              { value: 'started', label: 'Started lender conversations' },
              { value: 'not_started', label: 'Not yet explored financing' },
            ], buyerData, setBuyerData, true)}
          </div>
        );

      case 'readiness':
        return (
          <div style={styles.stepCard}>
            <h2 style={styles.stepTitle}>Financial Readiness</h2>
            <p style={styles.stepDesc}>
              Lenders will require documentation. Check what you currently have available.
            </p>
            {renderCheckboxGroup('readinessDocs', 'Do you have the following available?', [
              { value: 'tax_returns', label: 'Personal tax returns (last 2 years)' },
              { value: 'proof_funds', label: 'Proof of liquid funds' },
              { value: 'credit_680', label: 'Credit score 680+ (self-reported is fine)' },
            ], buyerData, setBuyerData)}
          </div>
        );

      case 'risk':
        return (
          <div style={styles.stepCard}>
            <h2 style={styles.stepTitle}>Risk Tolerance</h2>
            <p style={styles.stepDesc}>
              Understanding your comfort level helps us find the right match.
            </p>
            {renderCheckboxGroup('riskComfort', 'Are you comfortable acquiring a business with:', [
              { value: 'existing_debt', label: 'Existing debt' },
              { value: 'equipment_leases', label: 'Equipment leases' },
              { value: 'seasonality', label: 'Revenue seasonality' },
              { value: 'staff_dependency', label: 'Staff dependency' },
            ], buyerData, setBuyerData)}
            {renderCheckboxGroup('dealStructure', 'Are you open to:', [
              { value: 'seller_financing', label: 'Seller financing' },
              { value: 'earnouts', label: 'Earn-outs' },
              { value: 'transition_agreements', label: 'Transition support agreements' },
            ], buyerData, setBuyerData)}
          </div>
        );

      case 'clinical':
        return (
          <div style={styles.stepCard}>
            <h2 style={styles.stepTitle}>Clinical & Compliance Readiness</h2>
            <p style={styles.stepDesc}>
              Med spas have specific regulatory requirements. Let's understand your situation.
            </p>
            {renderRadioGroup('isLicensed', 'Are you currently licensed or credentialed to work in a med spa?', [
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' },
            ], buyerData, setBuyerData, true)}
            {renderCheckboxGroup('clinicalNeeds', 'Will you require:', [
              { value: 'medical_director', label: 'Medical Director' },
              { value: 'mso_pc', label: 'MSO/PC structure setup' },
              { value: 'compliance_guidance', label: 'Compliance guidance' },
            ], buyerData, setBuyerData)}
          </div>
        );

      case 'postclose':
        return (
          <div style={styles.stepCard}>
            <h2 style={styles.stepTitle}>Post-Close Intentions</h2>
            <p style={styles.stepDesc}>
              What are your plans after acquiring the business?
            </p>
            {renderCheckboxGroup('postCloseIntentions', 'Do you plan to:', [
              { value: 'keep_brand', label: 'Keep brand as-is' },
              { value: 'rebrand', label: 'Rebrand' },
              { value: 'expand_services', label: 'Expand services' },
              { value: 'add_locations', label: 'Add locations' },
            ], buyerData, setBuyerData)}
          </div>
        );

      default:
        return null;
    }
  };

  // ─────────────────────────────────────────────────────────────────────────
  // RESULTS SCREENS
  // ─────────────────────────────────────────────────────────────────────────
  const renderSellerResults = () => {
    if (!readinessScore) return null;
    
    const getTierStyle = () => {
      switch (readinessScore.tier) {
        case 'market-ready': return styles.tierGreen;
        case 'optimizable': return styles.tierYellow;
        default: return styles.tierRed;
      }
    };

    const getTierLabel = () => {
      switch (readinessScore.tier) {
        case 'market-ready': return 'Market Ready';
        case 'optimizable': return 'Value-Optimizable';
        default: return 'Not Yet Sale-Ready';
      }
    };

    const getTierMessage = () => {
      switch (readinessScore.tier) {
        case 'market-ready':
          return "Your business can be valued immediately and is buyer & lender friendly. You're eligible for premium multiples. Let's discuss your valuation and listing strategy.";
        case 'optimizable':
          return "Your business is sellable but may be leaving money on the table. A short optimization sprint (30-90 days) could materially improve your outcome.";
        default:
          return "At this stage, valuation will likely be discounted and buyer confidence low. We recommend a stabilization and cleanup engagement before going to market.";
      }
    };

    const breakdownLabels = {
      financial: 'Financial Readiness',
      revenue: 'Revenue Quality & Predictability',
      debt: 'Debt & Liability Clarity',
      staffing: 'Operational & Staffing Stability',
      compliance: 'Compliance & Structure',
      brand: 'Market & Brand Strength',
    };

    return (
      <div style={styles.resultsContainer}>
        <div style={styles.scoreCard}>
          <div style={styles.scoreGlow} />
          <img 
            src={STRATAVERA_LOGO}
            alt="StrataVera"
            style={{ width: '140px', marginBottom: '24px', position: 'relative', zIndex: 1 }}
          />
          <div style={styles.scoreNumber}>{readinessScore.total}</div>
          <div style={styles.scoreLabel}>Valuation Readiness Score</div>
          <div style={{ ...styles.tierBadge, ...getTierStyle() }}>
            {getTierLabel()}
          </div>
        </div>

        <div style={styles.breakdownCard}>
          <h3 style={styles.breakdownTitle}>Score Breakdown</h3>
          {Object.entries(readinessScore.breakdown).map(([key, value]) => (
            <div key={key} style={styles.breakdownItem}>
              <span style={styles.breakdownLabel}>{breakdownLabels[key]}</span>
              <span style={styles.breakdownScore}>{value.score} / {value.max}</span>
            </div>
          ))}
        </div>

        <div style={styles.nextStepsCard}>
          <h3 style={styles.nextStepsTitle}>What This Means</h3>
          <p style={styles.nextStepsText}>{getTierMessage()}</p>
          <p style={{ ...styles.nextStepsText, marginTop: '16px', marginBottom: 0 }}>
            <strong>Next step:</strong> We'll be in touch within 24 hours to discuss your results and explore what's possible.
          </p>
        </div>
      </div>
    );
  };

  const renderBuyerResults = () => {
    return (
      <div style={styles.resultsContainer}>
        <div style={styles.scoreCard}>
          <div style={styles.scoreGlow} />
          <img 
            src={STRATAVERA_LOGO}
            alt="StrataVera"
            style={{ width: '140px', marginBottom: '24px', position: 'relative', zIndex: 1 }}
          />
          <div style={{ ...styles.scoreNumber, fontSize: '48px', marginBottom: '16px' }}>✓</div>
          <div style={{ ...styles.heroTitle, fontSize: '28px', margin: 0, color: colors.porcelain }}>Application Received</div>
          <div style={styles.scoreLabel}>Buyer Intake Complete</div>
        </div>

        <div style={styles.breakdownCard}>
          <h3 style={styles.breakdownTitle}>Your Profile Summary</h3>
          <div style={styles.breakdownItem}>
            <span style={styles.breakdownLabel}>Buyer Type</span>
            <span style={styles.breakdownScore}>
              {buyerData.buyerType === 'first_time' ? 'First-time Buyer' :
               buyerData.buyerType === 'existing_owner' ? 'Existing Owner' :
               buyerData.buyerType === 'healthcare_pro' ? 'Healthcare Professional' :
               buyerData.buyerType === 'investor' ? 'Investor/Operator' : 'Not specified'}
            </span>
          </div>
          <div style={styles.breakdownItem}>
            <span style={styles.breakdownLabel}>Funding Method</span>
            <span style={styles.breakdownScore}>
              {buyerData.fundingMethod === 'cash' ? 'Cash' :
               buyerData.fundingMethod === 'sba' ? 'SBA Loan' :
               buyerData.fundingMethod === 'conventional' ? 'Conventional Loan' :
               buyerData.fundingMethod === 'private' ? 'Private Financing' :
               buyerData.fundingMethod === 'combination' ? 'Combination' : 'Not specified'}
            </span>
          </div>
          <div style={styles.breakdownItem}>
            <span style={styles.breakdownLabel}>Timeline</span>
            <span style={styles.breakdownScore}>
              {buyerData.acquisitionTimeline === 'asap' ? 'ASAP' :
               buyerData.acquisitionTimeline === '3-6months' ? '3-6 Months' :
               'Flexible'}
            </span>
          </div>
          <div style={styles.breakdownItem}>
            <span style={styles.breakdownLabel}>Licensed</span>
            <span style={styles.breakdownScore}>{buyerData.isLicensed === 'yes' ? 'Yes' : 'No'}</span>
          </div>
        </div>

        <div style={styles.nextStepsCard}>
          <h3 style={styles.nextStepsTitle}>What Happens Next</h3>
          <p style={styles.nextStepsText}>
            We've received your information and will review your profile to match you with suitable opportunities. 
            {buyerData.fundingMethod !== 'cash' && buyerData.financingStatus !== 'prequalified' && (
              <span> Since you're planning to use financing, we recommend starting lender conversations early — this significantly strengthens your position as a buyer.</span>
            )}
          </p>
          <p style={{ ...styles.nextStepsText, marginTop: '16px', marginBottom: 0 }}>
            <strong>Expect to hear from us within 48 hours</strong> with next steps and any available opportunities that match your criteria.
          </p>
        </div>
      </div>
    );
  };

  // ─────────────────────────────────────────────────────────────────────────
  // MAIN RENDER
  // ─────────────────────────────────────────────────────────────────────────
  const steps = pathway === 'seller' ? activeSellerSteps : activeBuyerSteps;
  const progress = steps.length > 0 ? ((currentStep + 1) / steps.length) * 100 : 0;
  const isLastStep = currentStep === steps.length - 1;
  const hasErrors = Object.keys(errors).length > 0;

  return (
    <div style={styles.page}>
      {/* Hero Section */}
      <header style={styles.hero}>
        <div style={styles.heroOverlay} />
        <div style={styles.heroContent}>
          <img 
            src={STRATAVERA_LOGO}
            alt="StrataVera"
            style={styles.logo}
          />
          <p style={styles.subhead}>Med Spa Advisory</p>
          <h1 style={styles.heroTitle}>
            {pathway === null 
              ? "Thinking About Selling or Buying a Med Spa?"
              : pathway === 'seller'
              ? "Seller Valuation Readiness Assessment"
              : "Buyer Qualification Assessment"
            }
          </h1>
          <p style={styles.heroSubtitle}>
            {pathway === null 
              ? "Clarity before complexity. Let's find out where you stand."
              : pathway === 'seller'
              ? "Discover your readiness score and what it means for your sale."
              : "Help us understand your position so we can match you with the right opportunity."
            }
          </p>

          {/* Pathway Selection */}
          {pathway === null && (
            <div style={styles.pathwayContainer}>
              <div
                style={{
                  ...styles.pathwayCard,
                  ...(hoveredPathway === 'seller' ? styles.pathwayCardHover : {}),
                }}
                onMouseEnter={() => setHoveredPathway('seller')}
                onMouseLeave={() => setHoveredPathway(null)}
                onClick={() => setPathway('seller')}
              >
                <div style={styles.pathwayIcon}>📋</div>
                <div style={styles.pathwayTitle}>I'm Selling</div>
                <div style={styles.pathwayDesc}>
                  Get your Valuation Readiness Score and understand what your business is worth.
                </div>
              </div>

              <div
                style={{
                  ...styles.pathwayCard,
                  ...(hoveredPathway === 'buyer' ? styles.pathwayCardHover : {}),
                }}
                onMouseEnter={() => setHoveredPathway('buyer')}
                onMouseLeave={() => setHoveredPathway(null)}
                onClick={() => setPathway('buyer')}
              >
                <div style={styles.pathwayIcon}>🔑</div>
                <div style={styles.pathwayTitle}>I'm Buying</div>
                <div style={styles.pathwayDesc}>
                  Complete your buyer profile and get matched with opportunities.
                </div>
              </div>
            </div>
          )}
        </div>
      </header>

      {/* Form Section */}
      {pathway !== null && !isComplete && (
        <section style={styles.formSection}>
          {/* Progress Bar */}
          <div style={styles.progressContainer}>
            <div style={styles.progressBar}>
              <div style={{ ...styles.progressFill, width: `${progress}%` }} />
            </div>
            <div style={styles.progressText}>
              <span>Step {currentStep + 1} of {steps.length}</span>
              <span>{steps[currentStep]?.title}</span>
            </div>
          </div>

          {/* Validation Summary */}
          {hasErrors && (
            <div style={styles.validationSummary}>
              <span style={styles.validationIcon}>⚠</span>
              <span style={styles.validationText}>
                Please complete all required fields before continuing.
              </span>
            </div>
          )}

          {/* Step Content */}
          {pathway === 'seller' ? renderSellerStep() : renderBuyerStep()}

          {/* Navigation Buttons */}
          <div style={styles.buttonRow}>
            {currentStep > 0 && (
              <button
                style={styles.buttonSecondary}
                onClick={handleBack}
              >
                Back
              </button>
            )}
            {!isLastStep ? (
              <button
                style={{
                  ...styles.buttonPrimary,
                  ...(hoveredButton === 'next' ? styles.buttonPrimaryHover : {}),
                }}
                onMouseEnter={() => setHoveredButton('next')}
                onMouseLeave={() => setHoveredButton(null)}
                onClick={handleNext}
              >
                Continue
              </button>
            ) : (
              <button
                style={{
                  ...styles.buttonPrimary,
                  ...(hoveredButton === 'submit' && !isSubmitting ? styles.buttonPrimaryHover : {}),
                  ...(isSubmitting ? styles.buttonPrimaryDisabled : {}),
                }}
                onMouseEnter={() => setHoveredButton('submit')}
                onMouseLeave={() => setHoveredButton(null)}
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Processing...' : pathway === 'seller' ? 'Get My Score' : 'Submit Application'}
              </button>
            )}
          </div>
        </section>
      )}

      {/* Results Section */}
      {isComplete && (
        pathway === 'seller' ? renderSellerResults() : renderBuyerResults()
      )}

      {/* Footer */}
      <footer style={styles.footer}>
        <img 
          src={STRATAVERA_LOGO}
          alt="StrataVera"
          style={styles.footerLogo}
        />
        <div style={styles.footerTagline}>Evolve Intentionally</div>
      </footer>
    </div>
  );
};

export default StrataVeraMedSpaIntake;
